<template>
  <div id="pageTable">
    <v-container fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                hide-details
                :placeholder="$t('search')"
                prepend-icon="search"
                solo
                v-model="search"
              ></v-text-field>
              <v-btn
                v-if="can('create', 'act')"
                small
                color="primary"
                @click="sendEmit('create')"
              >{{$t('new')}}</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="formatList"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                :search="search"
                class="elevation-1"
                item-key="_id"
                :loading="loading"
                :pagination.sync="pagination"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center px-0">
                    <v-btn
                      v-if="can('create', 'act')"
                      flat
                      icon
                      color="primary"
                      small
                      class="px-0 mx-0"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('clone', props.item._id)"
                      >file_copy</v-icon>
                    </v-btn>
                    <v-btn flat icon color="success" small class="px-0 mx-0">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('view', props.item._id)"
                      >visibility</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="can('edit', 'act', props.item)"
                      flat
                      icon
                      color="success"
                      small
                      class="px-0 mx-0"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('update', props.item._id)"
                      >create</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      small
                      color="error"
                      class="px-0 mx-0"
                      v-if="can('delete', 'act', props.item)"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('delete', props.item._id)"
                      >delete</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <i
                      class="success--text icon material-icons"
                      v-if="props.item.active"
                    >check_circle</i>
                    <i class="error--text icon material-icons" v-else>cancel</i>
                  </td>
                  <td style="min-width:230px">{{props.item.name}}</td>
                  <td>{{props.item.createdAt}}</td>
                  <td>{{ props.item.createdBy}}</td>

                  <td>{{props.item.updatedAt}}</td>
                  <td>{{props.item.updatedBy}}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogClone" max-width="290">
      <v-card>
        <v-card-title class="headline">Confirme Clonacion</v-card-title>

        <v-card-text>¿Realmente desea clonar este Acta?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" flat="flat" @click="yesClone()">Confirmar</v-btn>

          <v-btn color="error darken-1" flat="flat" @click="noClone()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{$t('confirmation')}}</v-card-title>

        <v-card-text>{{$t('confirmDeleteAct')}}</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" flat @click="actionRemove()">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateFormat, timeFormat } from '../../../helpers/dateHelper'
import { rangexy } from '../../../helpers'

export default {
  name: 'list',
  data() {
    return {
      isClone: null,
      dialog: false,
      rangeValue: 0,
      rangeSelect: [],
      search: '',
      selected: '',
      pagination: {
        sortBy: 'active',
        descending: true
      },
      complex: {
        headers: [
          {
            text: this.$t('actions'),
            value: ''
          },
          {
            text: this.$t('state'),
            value: 'active'
          },
          {
            text: this.$t('name'),
            value: 'name'
          },
          {
            text: this.$t('createdAt'),
            value: 'createdAt'
          },
          {
            text: this.$t('createdBy'),
            value: 'createdBy'
          },
          {
            text: this.$t('updatedAt'),
            value: 'updatedAt'
          },
          {
            text: this.$t('updatedBy'),
            value: 'updatedBy'
          }
        ]
      }
    }
  },
  mounted() {
    this.rangeValue = rangexy(0, 99)
    let me = this
    this.rangeValue.forEach(item => {
      me.rangeSelect.push({
        text: item + '',
        value: item + ''
      })
    })
  },

  computed: {
    ...mapState({
      loading: state => state.acts.loading,
      listActs: state => state.acts.list,
      listUser: state => state.users.listaUsers,
      actSel: state => state.acts.actSelected,
      authUser: state => state.authentication.user
    }),
    listActsForView() {
      if (!this.listActs) {
        return []
      }
      return this.listActs
    },
    formatList() {
      return this.listActs.map(act => {
        return {
          ...act,
          createdAt: dateFormat(act.createdAt),
          updatedAt: dateFormat(act.updatedAt)
        }
      })
    },
    dialogClone() {
      return this.isClone !== null
    }
  },
  methods: {
    ...mapActions({
      getOne: 'acts/setOne',
      remove: 'acts/setDelete',
      setClone: 'acts/setClone'
    }),
    sendEmit(evento, id = null) {
      if (
        evento !== 'delete' &&
        evento !== 'create' &&
        evento !== 'update' &&
        evento !== 'view' &&
        evento !== 'clone'
      ) {
        return
      }
      switch (evento) {
        case 'create':
          this.$emit('create')
          break
        case 'update':
          this.getOne(id).then(_ => {
            this.$emit('update')
          })
          break
        case 'delete':
          this.select = id
          this.dialog = true
          break
        case 'view':
          this.getOne(id).then(_ => {
            this.$emit('view')
          })
          break
        case 'clone':
          this.getOne(id).then(_ => {
            this.isClone = id
          })
          break
      }
    },
    formatLanguage(text, idLanguage) {
      let item = text.find(item => item.langId === idLanguage)
      return item ? item.text : '*'
    },
    actionRemove() {
      this.remove(this.select)
      this.dialog = false
      let me = this
      setTimeout(function() {
        me.select = ''
      }, 500)
    },
    noClone() {
      this.isClone = null
    },
    yesClone() {
      if (this.isClone) {
        this.setClone(this.actSel)
      }
      this.isClone = null
    }
  }
}
</script>

<style scoped>
.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
